import { render, staticRenderFns } from "./SecDesktopNotification.vue?vue&type=template&id=5a4e4a43&lang=true"
import script from "./SecDesktopNotification.vue?vue&type=script&lang=js"
export * from "./SecDesktopNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports